(() => {
  const initialize = (loginForm) => {
    const element = loginForm.element;
    const options = JSON.parse(loginForm.options);
    const ssoLink = element.querySelector('form > a');

    ssoLink.text = options.linkText;

    // Append desired element to the fragment:
    element.querySelector('.login-form__sso').appendChild(ssoLink);
  };

  const loginForm = stp.setup('login-form');

  loginForm.map(initialize);
})();
